module.exports = __webpack_public_path__ + "static/media/resetSearch-dark.baf8241f.svg";